import jstz from 'jstz';

/**
 * Gets the user timezone from the browser
 */
export default function() {
  return jstz.determine().name();
}
